import styled from '@emotion/styled'
import { Drawer } from 'antd'

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    width: auto;
    right: 0px;
  }

  .ant-drawer-body {
    padding: 15px;
    margin-bottom: 26px;
  }
`
